import { useEffect, useRef } from 'react';

export const useScrollToTodayGroup = () => {
  const todayGroupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    todayGroupRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return todayGroupRef;
};
